export default "__VITE_ASSET__rPuMDMUr__"